<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-05 18:08:33
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveType\components\newTransactionType.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-11-02 10:40:36
-->
<template>
  <normalDialog
    :title="
      $t('label_essweb_leaveType_form_dialog_addLeaveTransactionTypeTitle')
    "
    :dialog="show"
    @close="closeDialog"
    width="600"
    scrollable
  >
    <template v-slot:content>
      <v-form ref="form">
        <v-row>
          <!-- 2021-07-16 改为下拉 brain -->
          <!-- <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pt-0 pb-0">
            <v-switch
              color="primary"
              class="ml-4"
              v-model="leaveTransactionTypeData.is_default"
              :label="
                leaveTransactionTypeData.is_default
                  ? $t('label_essweb_RosterTemplate_form_setAsDefault')
                  : ''
              "
            ></v-switch>
          </v-col> -->
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :bindData="leaveTransactionTypeData.leave_transaction_type_name"
              maxlength="100"
              :TrigerInit="show"
              @change="
                (valueArr) => {
                  leaveTransactionTypeData.leave_transaction_type_name =
                    valueArr;
                }
              "
              :label="
                $t(
                  'label_essweb_leaveType_form_dialog_leaveTransactionTypeNameLabel'
                )
              "
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_leaveType_form_dialog_calculationMethodLabel")
            }}</v-sheet>
            <v-autocomplete
              v-model="leaveTransactionTypeData.calculation_method"
              :items="Calculations"
              filled
              item-value="value_field"
              item-text="view_fields"
              single-line
              :rules="$GetRules('_Require_Rules', [null])"
              dense
              :label="
                $t('label_essweb_leaveType_form_dialog_calculationMethodLabel')
              "
            >
              <template v-slot:no-data>
                <noContent />
              </template>
              <template v-slot:selection="{ item, index }">
                {{ $getCommonLangValue(item.view_fields) }}
              </template>
              <template v-slot:item="{ item, index }">
                {{ $getCommonLangValue(item.view_fields) }}
              </template></v-autocomplete
            >
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              type="number"
              maxlength="255"
              :rules="
                $GetRules(['_Number_negative', '_Length_Rules'], [null, 255])
              "
              isNotRequire
              :label="$t('label_essweb_leaveType_form_dialog_sequenceLabel')"
              v-model="leaveTransactionTypeData.sequence"
            />
          </v-col>
          <v-col xs="12" sm="12" md="6" lg="6" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_leaveType_form_dialog_enumerationCodeLabel")
            }}</v-sheet>
            <v-autocomplete
              v-model="leaveTransactionTypeData.leave_transaction_type_code"
              :items="TransactionCode"
              filled
              item-value="value_field"
              item-text="view_fields"
              single-line
              :rules="$GetRules('_Require_Rules', [null])"
              dense
              :label="
                $t('label_essweb_leaveType_form_dialog_enumerationCodeLabel')
              "
            >
              <template v-slot:no-data>
                <noContent />
              </template>
              <template v-slot:selection="{ item, index }">
                {{ $getCommonLangValue(item.view_fields) }}
              </template>
              <template v-slot:item="{ item, index }">
                {{ $getCommonLangValue(item.view_fields) }}
              </template></v-autocomplete
            >
          </v-col>
          <v-col xs="12" sm="12" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_RosterTemplate_form_setAsDefault")
            }}</v-sheet>
            <v-autocomplete
              v-model="leaveTransactionTypeData.is_default"
              :items="trueFalse"
              item-value="value_field"
              item-text="view_fields"
              filled
              single-line
              dense
              :label="$t('label_essweb_RosterTemplate_form_setAsDefault')"
            >
              <template v-slot:no-data> <noContent /> </template>
              <template v-slot:selection="data">
                {{ $getCommonLangValue(data.item.view_fields) }}
              </template>
              <template v-slot:item="data">
                {{ $getCommonLangValue(data.item.view_fields) }}
              </template>
            </v-autocomplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveType_form_dialog_codeLabel")
            }}</v-sheet>
            <v-text-field
              dense
              filled
              single-line
              maxlength="100"
              :label="$t('label_essweb_leaveType_form_dialog_codeLabel')"
              v-model="
                leaveTransactionTypeData.leave_transaction_type_common_code
              "
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :TrigerInit="show"
              maxlength="500"
              :bindData="
                leaveTransactionTypeData.leave_transaction_type_description
              "
              @change="
                (valueArr) => {
                  leaveTransactionTypeData.leave_transaction_type_description =
                    valueArr;
                }
              "
              :label="$t('label_essweb_leaveType_form_dialog_descriptionLabel')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t(
                "label_essweb_leaveType_form_dialog_leaveTransactionGroupLabel"
              )
            }}</v-sheet>
            <v-autocomplete
              v-model="
                leaveTransactionTypeData.leave_transaction_type_property_group_uuid
              "
              :items="LeaveTranPG"
              item-value="uuid"
              item-text="leave_transaction_type_property_group_code"
              filled
              single-line
              :rules="$GetRules('_Require_Rules', [null])"
              dense
              :label="
                $t(
                  'label_essweb_leaveType_form_dialog_leaveTransactionGroupLabel'
                )
              "
            >
              <template v-slot:no-data> <noContent /> </template>
              <template v-slot:selection="data">
                {{
                  $getCommonLangValue(
                    data.item.leave_transaction_type_property_group_name
                  )
                }}
              </template>
              <template v-slot:item="data">
                {{
                  $getCommonLangValue(
                    data.item.leave_transaction_type_property_group_name
                  )
                }}
              </template>
            </v-autocomplete>
          </v-col>
          <!-- 2022-11-02 bug348 BJ 去掉这两个字段  -->
          <!-- <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_leaveType_form_dialog_approvalTemplateLabel")
            }}</v-sheet>
            <v-autocomplete
              v-model="leaveTransactionTypeData.approval_flow_template_uuid"
              :items="ApprovalTemplates"
              item-value="uuid"
              item-text="flow_template_name"
              filled
              single-line
              :rules="$GetRules('_Require_Rules', [null])"
              dense
              :label="
                $t('label_essweb_leaveType_form_dialog_approvalTemplateLabel')
              "
            >
              <template v-slot:no-data> <noContent /> </template>
              <template v-slot:selection="data">
                {{ $getCommonLangValue(data.item.flow_template_name) }}
              </template>
              <template v-slot:item="data">
                {{ $getCommonLangValue(data.item.flow_template_name) }}
              </template>
            </v-autocomplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t(
                "label_essweb_leaveType_form_dialog_overBalanceApprovalTemplateLabel"
              )
            }}</v-sheet>
            <v-autocomplete
              v-model="
                leaveTransactionTypeData.over_balance_approval_flow_template_uuid
              "
              :items="ApprovalTemplates"
              item-value="uuid"
              item-text="flow_template_name"
              filled
              single-line
              :rules="$GetRules('_Require_Rules', [null])"
              dense
              :label="
                $t(
                  'label_essweb_leaveType_form_dialog_overBalanceApprovalTemplateLabel'
                )
              "
            >
              <template v-slot:no-data> <noContent /> </template>
              <template v-slot:selection="data">
                {{ $getCommonLangValue(data.item.flow_template_name) }}
              </template>
              <template v-slot:item="data">
                {{ $getCommonLangValue(data.item.flow_template_name) }}
              </template>
            </v-autocomplete>
          </v-col> -->
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions newBtn @new="toNew" @cancel="closeDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newLeaveTransactionType",
  computed: {
    ...mapGetters(["companyLang"]),
  },
  props: {
    show: { default: false, type: Boolean },
  },
  data() {
    return {
      LeaveTranPG: [],
      Calculations: [],
      trueFalse: [],
      TransactionCode: [],
      ApprovalTemplates: [],
      leaveTransactionTypeData: {
        leave_transaction_type_name: "",
        leave_transaction_type_code: "",
        leave_transaction_type_common_code: "",
        leave_transaction_type_description: "",
        // approval_flow_template_uuid: "",
        leave_transaction_type_property_group_uuid: "",
        leave_type_uuid: "",
        calculation_method: "",
        is_default: 0,
        sequence: 1,
        // over_balance_approval_flow_template_uuid: "",
        is_default: "",
        remarks: "",
      },
    };
  },
  watch: {
    show(val) {
      if (val) {
        // this.$nextTick(() => {
        if (this.$refs["form"]) this.$refs["form"].reset();
        // });
      } else {
        if (this.$refs["form"]) this.$refs["form"].reset();
        this.leaveTransactionTypeData = {
          leave_transaction_type_name: "",
          leave_transaction_type_code: "",
          leave_transaction_type_common_code: "",
          leave_transaction_type_description: "",
          // approval_flow_template_uuid: "",
          leave_transaction_type_property_group_uuid: "",
          leave_type_uuid: "",
          calculation_method: "",
          is_default: false,
          // over_balance_approval_flow_template_uuid: "",
          sequence: 1,
          is_default: "",
          remarks: "",
        };
      }
    },
  },
  mounted() {
    this.leaveTransactionTypeData.leave_transaction_type_name =
      this.$getCommonLangKey(this.companyLang);
    this.leaveTransactionTypeData.leave_transaction_type_description =
      this.$getCommonLangKey(this.companyLang);
    this.getCalculation();
    this.getTransactionCode();
    this.getDefault();
    this.getLeaveTranPG();
    this.getApprovalTemplates();
    this.$nextTick(() => {
      if (this.$refs["form"]) this.$refs["form"].reset();
    });
  },
  methods: {
    getCalculation: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_calculation_method_select",
      }).then((res) => {
        that.Calculations = res.data;
      });
    },
    getTransactionCode: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "transaction_type_code_leave_select",
      }).then((res) => {
        that.TransactionCode = res.data;
      });
    },
    getDefault: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_boolean_select",
      }).then((res) => {
        that.trueFalse = res.data;
      });
    },
    getLeaveTranPG: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_type_property_group",
        url: "/leave-transaction-type-property-group/get-list/",
        data: {},
      }).then((res) => {
        that.LeaveTranPG = res.data;
      });
    },
    getApprovalTemplates: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_templates",
        url: "/approval-template/get-approval-template-list/",
        data: {
          business_data_table_name: "ess_lv_leave_application_record", //bj 2021-07-05
        },
      }).then((res) => {
        that.ApprovalTemplates = res.data;
      });
    },
    closeDialog: function () {
      this.$emit("close");
    },
    toNew: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("onNew", this.leaveTransactionTypeData);
    },
  },
};
</script>
